import {
  Dialog,
  DialogSurface,
  DialogBody,
  DialogTitle,
  DialogContent,
  DialogActions,
} from '@fluentui/react-components';
import { CheckmarkCircle24Filled, Dismiss24Regular } from '@fluentui/react-icons';
import { useTranslation } from 'react-i18next';
import { BasicButton } from '@components/common/BasicButton';
import { useCancelSuccessDialogStyles } from './CancelSuccessDialog.styles';

export interface CancelSuccessDialogProps {
  open: boolean;
  onClose: () => void;
}

export const CancelSuccessDialog = ({ open, onClose }: CancelSuccessDialogProps) => {
  const styles = useCancelSuccessDialogStyles();
  const { t } = useTranslation('planner');

  return (
    <Dialog
      open={open}
      modalType="modal"
      onOpenChange={(_, data) => {
        if (!data.open) {
          onClose();
        }
      }}
    >
      <DialogSurface className={styles.surface}>
        <DialogBody>
          <DialogTitle
            action={
              <BasicButton
                variant="subtle"
                size="medium"
                aria-label={t('cancelSuccessDialog.close')}
                icon={<Dismiss24Regular />}
                onClick={onClose}
              />
            }
          >
            <span className={styles.titleRow}>
              <CheckmarkCircle24Filled className={styles.successIcon} />
              {t('cancelSuccessDialog.title')}
            </span>
          </DialogTitle>
          <DialogContent>
            <p className={styles.bodyText}>{t('cancelSuccessDialog.body')}</p>
          </DialogContent>
          <DialogActions>
            <BasicButton
              variant="primary"
              size="medium"
              onClick={onClose}
              data-testid="cancel-success-close-button"
            >
              {t('cancelSuccessDialog.closeButton')}
            </BasicButton>
          </DialogActions>
        </DialogBody>
      </DialogSurface>
    </Dialog>
  );
};

CancelSuccessDialog.displayName = 'CancelSuccessDialog';
